import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { casesApi } from '../../network/apis/cases';
import '../../assets/css/doctor/cases.css'; // Reusing doctor cases styles

const AHTCases = () => {
    const navigate = useNavigate();
    const [cases, setCases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filterStatus, setFilterStatus] = useState('ALL');

    useEffect(() => {
        fetchCases();
    }, []);

    const fetchCases = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await casesApi.getCases();
            const casesData = response?.data?.data || response?.data || [];
            setCases(Array.isArray(casesData) ? casesData : []);
        } catch (err) {
            console.error('Failed to fetch cases:', err);
            setError(err.message || 'Failed to fetch cases');
            setCases([]);
        } finally {
            setLoading(false);
        }
    };

    const filteredCases = filterStatus === 'ALL' 
        ? cases 
        : cases.filter(c => c.status === filterStatus);

    const getStatusColor = (status) => {
        const colors = {
            'PENDING': '#FFA500',
            'ASSIGNED': '#2196F3',
            'IN_PROGRESS': '#FF9800',
            'RESOLVED': '#4CAF50',
            'CANCELLED': '#f44336'
        };
        return colors[status] || '#999';
    };

    if (loading) {
        return <div className="cases-container"><h2>Loading cases...</h2></div>;
    }

    return (
        <div className="cases-container">
            <div className="cases-header">
                <h1>Your Cases</h1>
                <p>Manage all your assigned cases here</p>
            </div>

            {error && (
                <div className="alert alert-error">{error}</div>
            )}

            {/* Status filters */}
            <div className="status-filters">
                {['ALL', 'PENDING', 'ASSIGNED', 'IN_PROGRESS', 'RESOLVED', 'CANCELLED'].map(status => (
                    <button
                        key={status}
                        className={`filter-btn ${filterStatus === status ? 'active' : ''}`}
                        onClick={() => setFilterStatus(status)}
                    >
                        {status}
                    </button>
                ))}
            </div>

            {/* Cases list */}
            {filteredCases.length > 0 ? (
                <div className="cases-grid">
                    {filteredCases.map(caseItem => (
                        <div key={caseItem.id} className="case-card">
                            <div className="case-header">
                                <h3>Case #{caseItem.id}</h3>
                                <span 
                                    className="status-badge"
                                    style={{ backgroundColor: getStatusColor(caseItem.status) }}
                                >
                                    {caseItem.status}
                                </span>
                            </div>
                            <div className="case-body">
                                <p><strong>Description:</strong> {caseItem.description || 'N/A'}</p>
                                <p><strong>Priority:</strong> {caseItem.priority || 'N/A'}</p>
                                <p><strong>Created:</strong> {new Date(caseItem.created_at).toLocaleDateString()}</p>
                            </div>
                            <div className="case-footer">
                                <button 
                                    onClick={() => navigate(`/aht/case/${caseItem.id}`)}
                                    className="view-details-btn"
                                >
                                    View Details
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="empty-state">
                    <h3>No cases found</h3>
                    <p>You don't have any {filterStatus !== 'ALL' ? filterStatus.toLowerCase() : ''} cases yet.</p>
                </div>
            )}
        </div>
    );
};

export default AHTCases;
